import { render, staticRenderFns } from "./PacketsReceiveProcess.vue?vue&type=template&id=a541fb58&scoped=true"
import script from "./PacketsReceiveProcess.vue?vue&type=script&lang=js"
export * from "./PacketsReceiveProcess.vue?vue&type=script&lang=js"
import style0 from "./PacketsReceiveProcess.vue?vue&type=style&index=0&id=a541fb58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a541fb58",
  null
  
)

export default component.exports